import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import { HicDataGridPro } from 'src/app/components/hic-vapor/datagrid/datagrid'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { keysOf } from 'src/utils/utils'

type ReferenceDocumentRow = {
  documentNumber?: string
  documentDate?: Date
  amount?: number
}

type ReferenceDocumentsListProps = {
  values?: ReferenceDocumentRow[]
}

export const ReferenceDocumentsList = (props: ReferenceDocumentsListProps) => {
  const { currency } = useTenant()
  const { formatCurrency } = useFormatCurrency()
  const dateFormat = useFormatDate()
  const { t } = useTranslation()

  const fields = keysOf<ReferenceDocumentRow>()

  const columns: GridColDef[] = [
    { field: fields('documentNumber'), headerName: t('pms.accounting.documents.progressive'), minWidth: 150 },
    { field: fields('documentDate'), headerName: t('pms.accounting.documents.document_date'), type: 'date', valueFormatter: ({ value }) => (value ? dateFormat(value) : ''), minWidth: 150 },
    { field: fields('amount'), headerName: t('commons.paid_amount'), type: 'number', valueFormatter: ({ value }) => formatCurrency(value ?? 0, currency), minWidth: 200 },
    { field: '#', sortable: false, headerName: '', flex: 1 },
  ]

  return (
    <HicDataGridPro //
      sx={{
        '& .MuiDataGrid-cell--editable:hover': {
          bgcolor: (theme) => theme.palette.action.hover,
          borderBottomColor: (theme) => theme.palette.secondary.main,
          color: (theme) => theme.palette.secondary.main,
        },
      }}
      rows={props.values ?? []}
      columns={columns}
      getRowId={(r) => r.documentNumber}
      autoHeight
      hideFooter
    />
  )
}
